export default __webpack_public_path__ + "static/notHungry-365a6c518b6556fa9b98b19aff681733.svg";